export const adaptGroupMember = (item: IGroupMember): GroupMember => {
	return {
		userId: item.user_id,
		name: item.name,
		email: item.email ?? null,
		role: item.role ?? null,
		source: item.source,
		storeName: item.store?.name ?? null
	};
};

export const adaptGroupMembers = (items: IGroupMember[]): GroupMember[] => {
	return items.map(adaptGroupMember);
};
